<ion-content>
  <ion-list>
    <ind-section-header [viewData]="sectionHeader" (onControlClick)="onSectionHeaderControlClick($event)"></ind-section-header>
    <ion-item class="info-item">
      <ion-label text-wrap> {{viewData.infoText}}</ion-label>
    </ion-item>
    <ion-item class="selection-item" *ngFor="let item of viewData.data; trackBy: trackById" (click)="onCheckboxClick(item)">
      <ion-checkbox labelPlacement="end"   justify="start" [checked]="item.isChecked">{{item.title}}</ion-checkbox>
      <!-- <ion-label>
        <ion-checkbox [checked]="item.isChecked"> </ion-checkbox>
        {{item.title}}
      </ion-label> -->
    </ion-item>
  </ion-list>
</ion-content>